/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for generateSQL. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="generateSQL"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="asView"/&gt; &lt;enumeration value="minimized"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class GenerateSQL extends Enum{

	enumValue = null;

	/**
	 * Specifies that all query items appear in the generated SQL.
	 */
	static  AS_VIEW = GenerateSQL.newLiteral("asView");

	/**
	 * Specifies that only the required query items appear in the generated SQL.
	 */
	static  MINIMIZED = GenerateSQL.newLiteral("minimized");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < GenerateSQL.values().length); ++i) {
			if (GenerateSQL.values()[i].enumValue == v) {
				return GenerateSQL.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("GenerateSQL" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/GenerateSQL.js